import React from "react";

export const MenuItemLink = ({
    title,
    icon,
    disabled,
    active,
    isChild = false,
    badge,
    accent,
    pulse,
    onClick,
}) => {
    const mainClass = `${!isChild ? "menuItem" : "submenuItem"} ${
        disabled ? "disabled" : ""
    } ${active ? "active" : ""} ${pulse && !disabled ? "pulse" : ""}`;

    return (
        <div
            data-testid="menu-item-link"
            data-accent={accent}
            className={mainClass}
            onClick={disabled ? undefined : onClick}
        >
            <span className={"menuIcon"}>{icon}</span>
            <span className={"menuLabel"}>
                {title}
                {badge && (
                    <span data-testid="menu-item-badge" className={"menuBadge"}>
                        {badge}
                    </span>
                )}
            </span>
        </div>
    );
};
